export default "__VITE_ASSET__BUfkF6w5__"